export const getQueryKeyBase = (baseKey, ...args) => {
    if (!args) {
        return [baseKey];
    }
    return [baseKey, ...args];
};

export const QUERY_KEYS = {
    LISTS: 'lists',
    CODES: 'codes',
    CODE_SYSTEMS: 'code-systems',
    CONCEPTS: 'concepts',
    VALUE_SETS: 'value-sets'
};

export const MUTATION_KEYS = {
    LISTS: 'lists'
};
